import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import React from 'react';
import '../SesameCashEnroll/SesameCashEnrollModule.scss';
import { Button } from 'components/form/Button/Button';
import classnames from 'classnames';

const CheckBulletPoint = props => {
  return (
    <FlexContainer className={'align-items-center'}>
      <Image className={'sesamecashEnrollCheckIcon'} />
      <Label className={'Body-2 mCaption'}>{props.text}</Label>
    </FlexContainer>
  );
};

const SesameCashEnrollModuleView = props => {
  const { copyConfig, onLearnMore } = props;

  const defaultConfig = {
    title: 'Credit Builder can build your credit with everyday purchases',
    subtitle: '',
    bullets: ['No credit check', '0% APR', 'No upfront security deposit'],
    ctaText: 'Learn More',
  };

  let finalConfig = copyConfig ? copyConfig : defaultConfig;

  let imageAlignmentClasses = classnames('m-justify-between ', {
    'm-flex-column': props.isImageColumn,
  });
  let imageWrapClasses = classnames('d-hide ', {
    'm-format100 margTB20': props.isImageColumn,
    'm-format30': !props.isImageColumn,
  });

  return (
    <SectionContainer
      className={'sesameCashEnrollModuleContainer padLR48 m-padLR16'}
    >
      <FlexContainer justifyBetween alignItemsCenter>
        <FlexContainer column className="infoContainer">
          <Label typeHeader={'h5'} className="H5 mSubtitle-1">
            {finalConfig?.title}
          </Label>

          <FlexContainer className={imageAlignmentClasses}>
            <FlexContainer column className="bulletContainer">
              {finalConfig?.subtitle && <Label>{finalConfig?.subtitle}</Label>}

              {finalConfig?.bullets?.length > 0 &&
                finalConfig?.bullets?.map((bullet, index) => {
                  return <CheckBulletPoint text={bullet} />;
                })}
            </FlexContainer>
            <Label className={imageWrapClasses}>
              {props?.imagePath && (
                <img
                  src={props?.imagePath}
                  alt={finalConfig?.title}
                  className="format100"
                />
              )}
            </Label>
          </FlexContainer>

          <Button
            mrphType="primary"
            onClick={onLearnMore}
            className="border-rad4px margT learnMoreButton"
          >
            Learn More
          </Button>
        </FlexContainer>
        <FlexContainer className="m-hide format40 mformat100">
          {props?.imagePath && (
            <img
              src={props?.imagePath}
              alt={finalConfig?.title}
              style={{ maxWidth: '100%' }}
            />
          )}
        </FlexContainer>
      </FlexContainer>
    </SectionContainer>
  );
};

export default SesameCashEnrollModuleView;

SesameCashEnrollModuleView.defaultProps = {
  isImageColumn: false,
  imagePath: '/images/art-cash-enroll.png',
};
